import React, { useState, useEffect, useRef, useContext } from "react";
import { LanguageContext } from "../languageContext";
import "../styles/Header.scss";
import { Link, useLocation } from "react-router-dom";
import getFetch from "./functions/fetching";

const Header = () => {
  const { lang } = useContext(LanguageContext);
  const { pathname } = useLocation();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isLangTabOpen, setIsLangTabOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [locales, setLocales] = useState([]);
  const ref = useRef(null);
  const screenRef = useRef(null);
  const localesRef = useRef(null);
  const localesMenuRef = useRef(null);
  const fethUrl = `https://esimus-property.com/app/api/header?locale=${lang}&populate[logo][populate][img][fields]=url&populate[nav][fields]`;

  useEffect(() => {
    if (!isFirstLoad) {
      fetchData();
    }
  }, [lang]);

  useEffect(() => {
    fetch(`https://esimus-property.com/app/api/i18n/locales`)
      .then((res) => res.json())
      .then((data) => setLocales(data.map((d) => d.code)))
      .then(() => fetchData())
      .then(() => setIsFirstLoad(false))
      .catch((err) => console.warn(err));
  }, []);

  useEffect(() => {
    if (isLoaded) {
      handleMenu(false);
    }
  }, [pathname]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        handleMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    function handleClickOutsideTab(e) {
      if (
        localesRef.current &&
        !localesRef.current.contains(e.target) &&
        !localesMenuRef.current.contains(e.target) &&
        isLangTabOpen
      ) {
        setIsLangTabOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutsideTab);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideTab);
    };
  }, [localesRef, isLangTabOpen]);

  const fetchData = () => {
    getFetch(fethUrl, error, setError, isLoaded, setIsLoaded, items, setItems);
  };

  const handleMenu = (shouldOpen) => {
    if (ref) {
      if (shouldOpen) {
        ref.current.classList.remove("header__mobileMenu_hidden");
        screenRef.current.classList.add("darkened");
        document.body.classList.add("stop-scrolling");
      } else {
        ref.current.classList.add("header__mobileMenu_hidden");
        screenRef.current.classList.remove("darkened");
        document.body.classList.remove("stop-scrolling");
      }
    }
  };

  const handleLanguagePick = (selection) => {
    localStorage.setItem("lang", selection);
    if (selection !== lang) {
      const event = new CustomEvent("LANG_CHANGED", {
        detail: {
          lang: selection,
        },
      });
      document.dispatchEvent(event);
    }
    setIsLangTabOpen(false);
  };

  if (error) {
    return <div>Ошибка: {error.message}</div>;
  } else if (!isLoaded) {
    return <div className="fetch-loader"></div>;
  } else {
    return (
      <>
        <header className="header">
          <div className="container">
            <div className="header__body">
              <div className="header__logo">
                <Link to={items.data.attributes.logo.link}>
                  <img
                    src={"https://esimus-property.com/app/uploads/esimus_service_logo_normal_3978751c3b.png"}
                    alt="logo"
                  />
                </Link>
              </div>
              <nav className="header__menu">
                <ul>
                  {items.data.attributes.nav.map((item) => (
                    <li key={item.id} className={pathname === item.link ? "sel" : ""}>
                      <Link to={item.link}>{item.text}</Link>
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="locales" onClick={() => setIsLangTabOpen((prev) => !prev)} ref={localesMenuRef}>
                <div className="locales__current-language">{lang.replace("el-CY", "gr")}</div>
                <div className={`locales__arrow${isLangTabOpen ? " locales__arrow_open" : ""}`}>
                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7 1L4 4L1 1"
                      stroke="#99C455"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
              <div className="header__hamburger" onClick={() => handleMenu(true)}>
                <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 1.5C0.5 0.947715 0.947715 0.5 1.5 0.5H16.5C17.0523 0.5 17.5 0.947715 17.5 1.5C17.5 2.05228 17.0523 2.5 16.5 2.5H1.5C0.947715 2.5 0.5 2.05228 0.5 1.5ZM0.5 7.5C0.5 6.94772 0.947715 6.5 1.5 6.5H16.5C17.0523 6.5 17.5 6.94772 17.5 7.5C17.5 8.05228 17.0523 8.5 16.5 8.5H1.5C0.947715 8.5 0.5 8.05228 0.5 7.5ZM1.5 12.5C0.947715 12.5 0.5 12.9477 0.5 13.5C0.5 14.0523 0.947715 14.5 1.5 14.5H16.5C17.0523 14.5 17.5 14.0523 17.5 13.5C17.5 12.9477 17.0523 12.5 16.5 12.5H1.5Z"
                    fill="#222222"
                  />
                </svg>
              </div>
            </div>
          </div>
        </header>
        <div className={`locales__select${isLangTabOpen ? " locales__select_open" : ""}`} ref={localesRef}>
          {locales.map((l) => (
            <div className={`locales__option`} key={l} onClick={() => handleLanguagePick(l)}>
              {l.replace("el-CY", "gr")}
            </div>
          ))}
        </div>
        <div className="header__mobileMenu-screen" ref={screenRef}></div>
        <div ref={ref} className={`header__mobileMenu header__mobileMenu_hidden`}>
          <div className="header__mobileMenu-header">
            <div className="header__mobileMenu-menu">{items.data.attributes.menu}</div>
            <svg
              onClick={() => handleMenu(false)}
              className="header__mobile-close"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L7 7M7 7L13 13M7 7L13 1M7 7L1 13" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <ul>
            {items.data.attributes.nav.map((item) => (
              <li key={item.id}>
                <Link to={item.link}>{item.text}</Link>
              </li>
            ))}
          </ul>
          <a href="https://www.instagram.com/esimuspropertygroup?igsh=eGY3bHA2Y3owa2Qz" target="_blank">
            <svg width="55" height="56" viewBox="0 0 55 56" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M27.5046 49.0957C21.8671 49.0957 21.2025 49.0654 19.0025 48.9674C17.2869 48.9099 15.5935 48.5548 13.9952 47.9174C11.2299 46.8217 9.04323 44.5944 7.96812 41.7784C7.36611 40.1451 7.04141 38.4195 7.00791 36.6754C6.87958 34.4401 6.87958 33.7074 6.87958 28.0117C6.87958 22.2554 6.90937 21.5834 7.00791 19.3551C7.04214 17.6133 7.36683 15.8901 7.96812 14.2591C9.04207 11.4393 11.2323 9.21012 14.0021 8.11772C15.6031 7.50219 17.296 7.17072 19.0071 7.13772C21.1956 7.01172 21.9152 7.01172 27.5046 7.01172C33.1879 7.01172 33.841 7.04205 36.0067 7.13772C37.7222 7.17101 39.4195 7.50244 41.0254 8.11772C43.7944 9.21136 45.9842 11.4401 47.0594 14.2591C47.6715 15.9138 47.9979 17.664 48.0242 19.4321C48.1525 21.6674 48.1525 22.3977 48.1525 28.0911C48.1525 33.7844 48.1204 34.5311 48.0242 36.7407C47.99 38.4865 47.6646 40.2137 47.0617 41.8484C45.9838 44.6664 43.7939 46.8944 41.0254 47.9897C39.4218 48.6015 37.728 48.9321 36.0158 48.9674C33.8273 49.0957 33.11 49.0957 27.5046 49.0957ZM27.4267 10.7054C21.8212 10.7054 21.2392 10.7334 19.0506 10.8337C17.7443 10.8513 16.4507 11.0968 15.2258 11.5594C13.4171 12.2641 11.9859 13.7154 11.2865 15.5541C10.8286 16.8147 10.5875 18.1463 10.5737 19.4904C10.4523 21.7514 10.4523 22.3441 10.4523 28.0117C10.4523 33.6117 10.4729 34.2907 10.5737 36.5377C10.5943 37.8682 10.8352 39.1856 11.2865 40.4344C11.987 42.2719 13.4179 43.7221 15.2258 44.4267C16.4498 44.8924 17.744 45.1379 19.0506 45.1524C21.269 45.2831 21.8533 45.2831 27.4267 45.2831C33.0481 45.2831 33.6302 45.2551 35.8004 45.1524C37.1076 45.1362 38.4022 44.8907 39.6275 44.4267C41.4252 43.716 42.8471 42.2691 43.5462 40.4391C44.0032 39.1773 44.2443 37.8451 44.259 36.5004H44.2842C44.3827 34.2697 44.3827 33.6747 44.3827 27.9744C44.3827 22.2741 44.3575 21.6744 44.259 19.4461C44.2384 18.1171 43.9974 16.8012 43.5462 15.5541C42.8487 13.7214 41.4266 12.2717 39.6275 11.5594C38.4025 11.0944 37.1077 10.8489 35.8004 10.8337C33.5844 10.7054 33.0046 10.7054 27.4267 10.7054ZM27.5046 38.7894C23.2191 38.7922 19.3541 36.1661 17.712 32.1358C16.0699 28.1055 16.9742 23.4648 20.0031 20.3781C23.0321 17.2914 27.5891 16.3667 31.5488 18.0352C35.5086 19.7036 38.0912 23.6367 38.0921 28.0001C38.0858 33.9525 33.3508 38.7778 27.5046 38.7894ZM27.5046 20.9954C23.7076 20.9954 20.6296 24.1294 20.6296 27.9954C20.6296 31.8614 23.7076 34.9954 27.5046 34.9954C31.3015 34.9954 34.3796 31.8614 34.3796 27.9954C34.3708 24.1331 31.2979 21.0044 27.5046 20.9954ZM38.5046 19.3317C37.142 19.3266 36.0408 18.1991 36.0433 16.8117C36.0459 15.4244 37.1512 14.3011 38.5137 14.3011C39.8763 14.3011 40.9816 15.4244 40.9842 16.8117C40.9848 17.4811 40.7236 18.1231 40.2583 18.596C39.793 19.0688 39.162 19.3336 38.5046 19.3317Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </>
    );
  }
};

export default Header;
